import { render, staticRenderFns } from "./AiDashboard.vue?vue&type=template&id=3e536779&scoped=true"
import script from "./AiDashboard.vue?vue&type=script&lang=js"
export * from "./AiDashboard.vue?vue&type=script&lang=js"
import style0 from "./AiDashboard.vue?vue&type=style&index=0&id=3e536779&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e536779",
  null
  
)

export default component.exports